import { GiftCardForm } from '../../features/store-gc/presentation/components/GiftCardForm';
import PgcHero from '@/shared/assets/images/physical-gift-card/pgc-hero.webp';
import PgcBanner from '@/shared/assets/images/physical-gift-card/pgc-banner.webp';
import { useIsMobile } from '@/core/hooks/useMediaQuery';

const StoreGiftCardPage = () => {

  const isMobile = useIsMobile();

  return (
    <>
      <img src={PgcBanner} alt="BlueStone Physical Gift Card"
        className={`w-full object-cover object-center ${isMobile ? 'h-[80px]' : 'h-full'}`}
      />
    <div className={`${!isMobile && 'rounded-lg my-5'} max-w-5xl mx-auto bg-white shadow-sm border border-gray-100 flex flex-col md:flex-row overflow-hidden`}>
      <div className="w-full md:w-1/2 flex-shrink-0">
        <img src={PgcHero} alt="BlueStone Physical Gift Card" className="w-full h-full object-cover max-h-[300px] md:max-h-none"/>
      </div>
      <GiftCardForm />
    </div>
    </>
  );
};

export default StoreGiftCardPage;